// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
/* Breakpoints */
.ant-notification {
  z-index: 20000;
}
.crud-module__leftMargin--enFoW {
  margin-left: 16px !important;
}
.crud-module__actions--G3NaK {
  display: flex;
  justify-content: flex-start;
  gap: 16px;
}
.crud-module__inlineFiltersContainer--ZcAbL {
  display: flex;
  gap: 16px;
  margin-top: 16px;
  align-items: flex-start;
}
.crud-module__inlineFiltersWrapper--GWvFa {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 16px;
  overflow-x: auto;
  align-items: flex-start;
  flex: 1;
}
.crud-module__inlineFiltersWrapper--GWvFa .crud-module__formField--sem7S {
  min-width: 150px;
  flex-shrink: 0;
  display: inline-block;
}
.crud-module__inlineFiltersWrapper--GWvFa > div {
  min-width: 150px;
  max-width: 250px;
  flex-shrink: 0;
  display: inline-block;
}
.crud-module__clearAllButton--wjKIc {
  display: flex;
  align-items: flex-start;
  padding-top: 24px;
}
.crud-module__wrapper--Uhgkw .crud-module__header--DoVsU {
  margin-bottom: 16px;
}
.crud-module__wrapper--Uhgkw .crud-module__header--DoVsU .crud-module__filterForm--Cd7ur {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding: 0;
}
.crud-module__wrapper--Uhgkw .crud-module__header--DoVsU .crud-module__filterForm--Cd7ur .crud-module__searchRow--WT_e6 {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  width: 100%;
}
.crud-module__wrapper--Uhgkw .crud-module__header--DoVsU .crud-module__filterForm--Cd7ur .crud-module__searchRow--WT_e6 .crud-module__searchField--W5VHC {
  flex: 1;
  min-width: 0;
}
.crud-module__wrapper--Uhgkw .crud-module__header--DoVsU .crud-module__filterForm--Cd7ur .crud-module__searchRow--WT_e6 .crud-module__searchField--W5VHC > div {
  width: 100%;
}
.crud-module__wrapper--Uhgkw .crud-module__header--DoVsU .crud-module__filterForm--Cd7ur .crud-module__searchRow--WT_e6 .crud-module__searchRowActions--02Wp2 {
  display: flex;
  gap: 8px;
  align-items: flex-start;
  padding-top: 24px;
}
.crud-module__wrapper--Uhgkw .crud-module__header--DoVsU .crud-module__filterForm--Cd7ur .crud-module__searchRow--WT_e6 .crud-module__searchRowActions--02Wp2 .crud-module__inlineFilterToggle--IjzG6 {
  background: transparent;
  border: none;
  padding: 4px 16px 4px 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8c8c8c;
  transition: color 0.3s;
  height: 40px;
}
.crud-module__wrapper--Uhgkw .crud-module__header--DoVsU .crud-module__filterForm--Cd7ur .crud-module__searchRow--WT_e6 .crud-module__searchRowActions--02Wp2 .crud-module__inlineFilterToggle--IjzG6:hover {
  color: #595959;
}
.crud-module__wrapper--Uhgkw .crud-module__header--DoVsU .crud-module__filterForm--Cd7ur .crud-module__searchRow--WT_e6 .crud-module__searchRowActions--02Wp2 .crud-module__inlineFilterToggle--IjzG6:active {
  color: #262626;
}
.crud-module__wrapper--Uhgkw .crud-module__header--DoVsU .crud-module__filterForm--Cd7ur .crud-module__searchRow--WT_e6 .crud-module__searchRowActions--02Wp2 .crud-module__inlineFilterToggle--IjzG6:disabled {
  cursor: not-allowed;
  opacity: 0.4;
  color: #d9d9d9;
}
.crud-module__wrapper--Uhgkw .crud-module__header--DoVsU .crud-module__filterForm--Cd7ur .crud-module__searchRow--WT_e6 .crud-module__searchRowActions--02Wp2 .crud-module__inlineFilterToggle--IjzG6:disabled:hover {
  color: #d9d9d9;
}
.crud-module__wrapper--Uhgkw .crud-module__header--DoVsU .crud-module__filterForm--Cd7ur .crud-module__searchRow--WT_e6 .crud-module__searchRowActions--02Wp2 .crud-module__filterActions--siw5r {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  padding-top: 0;
}
.crud-module__wrapper--Uhgkw .crud-module__header--DoVsU .crud-module__filterForm--Cd7ur .crud-module__filtersRow--CwYUt {
  display: flex;
  gap: 16px;
  width: 100%;
  align-items: flex-start;
}
.crud-module__wrapper--Uhgkw .crud-module__header--DoVsU .crud-module__filterForm--Cd7ur .crud-module__filtersRow--CwYUt .crud-module__filterWidgets--YSveH {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: flex-start;
}
.crud-module__wrapper--Uhgkw .crud-module__header--DoVsU .crud-module__filterForm--Cd7ur .crud-module__filtersRow--CwYUt .crud-module__filterWidgets--YSveH .crud-module__formField--sem7S {
  min-width: 150px;
}
.crud-module__wrapper--Uhgkw .crud-module__header--DoVsU .crud-module__filterForm--Cd7ur .crud-module__filtersRow--CwYUt .crud-module__filterWidgets--YSveH > div {
  min-width: 150px;
}
.crud-module__wrapper--Uhgkw .crud-module__header--DoVsU .crud-module__filterForm--Cd7ur .crud-module__filtersRow--CwYUt .crud-module__filterActions--siw5r {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  padding-top: 24px;
}
.crud-module__wrapper--Uhgkw .crud-module__header--DoVsU .crud-module__filterForm--Cd7ur .crud-module__formField--sem7S {
  padding: 0;
  max-width: initial;
}
.crud-module__wrapper--Uhgkw .crud-module__header--DoVsU .crud-module__collapsedWrapper--HXSrH {
  margin-top: 16px;
  padding-bottom: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
@media only screen and (max-width: 1200px) {
  .crud-module__wrapper--Uhgkw .crud-module__header--DoVsU .crud-module__collapsedWrapper--HXSrH {
    justify-content: space-between;
  }
}
@media only screen and (max-width: 600px) {
  .crud-module__wrapper--Uhgkw .crud-module__header--DoVsU .crud-module__filterForm--Cd7ur .crud-module__searchRow--WT_e6 {
    flex-direction: column;
  }
  .crud-module__wrapper--Uhgkw .crud-module__header--DoVsU .crud-module__filterForm--Cd7ur .crud-module__searchRow--WT_e6 .crud-module__searchField--W5VHC {
    width: 100%;
  }
  .crud-module__wrapper--Uhgkw .crud-module__header--DoVsU .crud-module__filterForm--Cd7ur .crud-module__searchRow--WT_e6 .crud-module__searchRowActions--02Wp2 {
    width: 100%;
    justify-content: flex-end;
    padding-top: 0;
  }
  .crud-module__wrapper--Uhgkw .crud-module__header--DoVsU .crud-module__filterForm--Cd7ur .crud-module__searchRow--WT_e6 .crud-module__searchRowActions--02Wp2 .crud-module__filterActions--siw5r {
    padding-top: 0;
  }
  .crud-module__wrapper--Uhgkw .crud-module__header--DoVsU .crud-module__filterForm--Cd7ur .crud-module__inlineFiltersContainer--ZcAbL {
    flex-direction: column;
  }
  .crud-module__wrapper--Uhgkw .crud-module__header--DoVsU .crud-module__filterForm--Cd7ur .crud-module__inlineFiltersWrapper--GWvFa {
    flex-wrap: wrap;
    overflow-x: visible;
  }
  .crud-module__wrapper--Uhgkw .crud-module__header--DoVsU .crud-module__filterForm--Cd7ur .crud-module__inlineFiltersWrapper--GWvFa > div {
    width: 100%;
    flex-shrink: 1;
  }
  .crud-module__wrapper--Uhgkw .crud-module__header--DoVsU .crud-module__filterForm--Cd7ur .crud-module__clearAllButton--wjKIc {
    padding-top: 0;
    width: 100%;
    justify-content: flex-end;
  }
  .crud-module__wrapper--Uhgkw .crud-module__header--DoVsU .crud-module__filterForm--Cd7ur .crud-module__filtersRow--CwYUt {
    flex-direction: column;
  }
  .crud-module__wrapper--Uhgkw .crud-module__header--DoVsU .crud-module__filterForm--Cd7ur .crud-module__filtersRow--CwYUt .crud-module__filterWidgets--YSveH {
    width: 100%;
  }
  .crud-module__wrapper--Uhgkw .crud-module__header--DoVsU .crud-module__filterForm--Cd7ur .crud-module__filtersRow--CwYUt .crud-module__filterWidgets--YSveH > div {
    width: 100%;
  }
  .crud-module__wrapper--Uhgkw .crud-module__header--DoVsU .crud-module__filterForm--Cd7ur .crud-module__filtersRow--CwYUt .crud-module__filterActions--siw5r {
    width: 100%;
    justify-content: flex-end;
    padding-top: 0;
  }
  .crud-module__wrapper--Uhgkw .crud-module__header--DoVsU .crud-module__filterForm--Cd7ur .crud-module__formField--sem7S {
    width: 100%;
  }
}
.crud-module__nestedTable--RZFZz {
  min-height: initial !important;
}
.crud-module__nestedTable--RZFZz .loadingWrapper {
  padding: 20px 0 0;
}
.crud-module__table--GPSPc {
  background: transparent;
}
.crud-module__table--GPSPc .ant-table {
  background: transparent;
}
.crud-module__table--GPSPc .ant-table .ant-table-thead tr th {
  background-color: #005866;
  color: white;
  border-bottom: 1px solid black;
}
.crud-module__table--GPSPc .ant-table-expanded-row .ant-table-cell {
  background-color: transparent;
}
.crud-module__table--GPSPc .ant-table-expanded-row .ant-table-cell:hover {
  background-color: transparent;
}
.crud-module__table--GPSPc .crud-module__row--vIlD4 {
  background-color: transparent;
}
.crud-module__table--GPSPc .crud-module__row--vIlD4 td {
  border-bottom: 1px solid black;
  color: white;
}
.crud-module__table--GPSPc .crud-module__row--vIlD4:hover td {
  background-color: #ffffff !important;
}
.crud-module__nestedTable--RZFZz {
  background-color: transparent;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  padding-bottom: 40px;
}
.crud-module__wrapperTranslateInput--lnfQD {
  display: flex;
  flex: 1;
}
.crud-module__wrapperTranslateButton--rGl7u {
  display: flex;
  align-items: flex-end;
  padding-bottom: 24px;
  margin-left: 16px;
  gap: 8px;
}
.crud-module__wrapperTranslateButton--rGl7u button {
  display: flex;
  justify-content: center;
  align-items: center;
}
.crud-module__headerActions--utE46 {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}
.crud-module__nestedTable--RZFZz {
  padding-bottom: 32px;
  margin-bottom: 32px;
}
`, "",{"version":3,"sources":["webpack://./components/organisms/crud/crud.module.less","webpack://./styles/variables.less"],"names":[],"mappings":"AAAA,4FAA4F;AAC5F,6CAA6C;AAC7C,sBAAsB;AACtB,6FAA6F;AAC7F,gBAAgB;AC0JhB;EACE,cAAA;ADxJF;AALA;EACE,4BAAA;AAOF;AAJA;EACE,aAAA;EACA,2BAAA;EACA,SAAA;AAMF;AAHA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;AAKF;AAFA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,OAAA;AAIF;AAXA;EAUI,gBAAA;EACA,cAAA;EACA,qBAAA;AAIJ;AAhBA;EAgBI,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AAGJ;AACA;EACE,aAAA;EACA,uBAAA;EACA,iBAAA;AACF;AAEA;EAEI,mBAAA;AADJ;AADA;EAKM,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AADN;AARA;EAYQ,aAAA;EACA,SAAA;EACA,uBAAA;EACA,WAAA;AADR;AAdA;EAkBU,OAAA;EACA,YAAA;AADV;AAlBA;EAsBY,WAAA;AADZ;AArBA;EA2BU,aAAA;EACA,QAAA;EACA,uBAAA;EACA,iBAAA;AAHV;AA3BA;EAiCY,uBAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;EACA,YAAA;AAHZ;AAKY;EACE,cAAA;AAHd;AAMY;EACE,cAAA;AAJd;AAOY;EACE,mBAAA;EACA,YAAA;EACA,cAAA;AALd;AAOc;EACE,cAAA;AALhB;AArDA;EAgEY,aAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;AARZ;AA3DA;EAyEQ,aAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;AAXR;AAjEA;EA+EU,OAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;EACA,uBAAA;AAXV;AAxEA;EAsFY,gBAAA;AAXZ;AA3EA;EA0FY,gBAAA;AAZZ;AA9EA;EA+FU,aAAA;EACA,SAAA;EACA,uBAAA;EACA,iBAAA;AAdV;AApFA;EAuGQ,UAAA;EACA,kBAAA;AAhBR;AAxFA;EA6GM,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;AAlBN;AAoBM;EAAA;IACE,8BAAA;EAjBN;AACF;AAqBE;EAAA;IAIQ,sBAAA;EArBR;EAiBA;IAOU,WAAA;EArBV;EAcA;IAWU,WAAA;IACA,yBAAA;IACA,cAAA;EAtBV;EASA;IAgBY,cAAA;EAtBZ;EAMA;IAsBQ,sBAAA;EAzBR;EAGA;IA0BQ,eAAA;IACA,mBAAA;EA1BR;EADA;IA8BU,WAAA;IACA,cAAA;EA1BV;EALA;IAoCQ,cAAA;IACA,WAAA;IACA,yBAAA;EA5BR;EAVA;IA0CQ,sBAAA;EA7BR;EAbA;IA6CU,WAAA;EA7BV;EAhBA;IAgDY,WAAA;EA7BZ;EAnBA;IAqDU,WAAA;IACA,yBAAA;IACA,cAAA;EA/BV;EAxBA;IA4DQ,WAAA;EAjCR;AACF;AAwCA;EACE,8BAAA;AAtCF;AAqCA;EAII,iBAAA;AAtCJ;AA0CA;EACE,uBAAA;AAxCF;AAuCA;EAII,uBAAA;AAxCJ;AAoCA;EASU,yBAAA;EACA,YAAA;EACA,8BAAA;AA1CV;AA+BA;EAmBM,6BAAA;AA/CN;AAiDM;EACE,6BAAA;AA/CR;AAyBA;EA4BI,6BAAA;AAlDJ;AAsBA;EA+BM,8BAAA;EACA,YAAA;AAlDN;AAqDI;EAEI,oCAAA;AApDR;AA0DA;EACE,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,oBAAA;AAxDF;AA4DA;EACE,aAAA;EACA,OAAA;AA1DF;AA6DA;EACE,aAAA;EACA,qBAAA;EACA,oBAAA;EACA,iBAAA;EACA,QAAA;AA3DF;AAsDA;EAQI,aAAA;EACA,uBAAA;EACA,mBAAA;AA3DJ;AA+DA;EACE,aAAA;EACA,SAAA;EACA,uBAAA;AA7DF;AAoEA;EACE,oBAAA;EACA,mBAAA;AAlEF","sourcesContent":["@import \"../../../styles/variables.less\";\n\n.leftMargin {\n  margin-left: 16px !important;\n}\n\n.actions {\n  display: flex;\n  justify-content: flex-start;\n  gap: 16px;\n}\n\n.inlineFiltersContainer {\n  display: flex;\n  gap: 16px;\n  margin-top: 16px;\n  align-items: flex-start;\n}\n\n.inlineFiltersWrapper {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  gap: 16px;\n  overflow-x: auto;\n  align-items: flex-start;\n  flex: 1;\n\n  .formField {\n    min-width: 150px;\n    flex-shrink: 0;\n    display: inline-block;\n  }\n\n  > div {\n    min-width: 150px;\n    max-width: 250px;\n    flex-shrink: 0;\n    display: inline-block;\n  }\n}\n\n.clearAllButton {\n  display: flex;\n  align-items: flex-start;\n  padding-top: 24px; // Align with input fields that have labels\n}\n\n.wrapper {\n  .header {\n    margin-bottom: 16px;\n\n    .filterForm {\n      display: flex;\n      flex-direction: column;\n      gap: 16px;\n      width: 100%;\n      padding: 0;\n\n      .searchRow {\n        display: flex;\n        gap: 16px;\n        align-items: flex-start;\n        width: 100%;\n\n        .searchField {\n          flex: 1;\n          min-width: 0;\n\n          > div {\n            width: 100%;\n          }\n        }\n\n        .searchRowActions {\n          display: flex;\n          gap: 8px;\n          align-items: flex-start;\n          padding-top: 24px; // Align with input fields that have labels\n\n          .inlineFilterToggle {\n            background: transparent;\n            border: none;\n            padding: 4px 16px 4px 4px;\n            cursor: pointer;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            color: #8c8c8c;\n            transition: color 0.3s;\n            height: 40px;\n\n            &:hover {\n              color: #595959;\n            }\n\n            &:active {\n              color: #262626;\n            }\n\n            &:disabled {\n              cursor: not-allowed;\n              opacity: 0.4;\n              color: #d9d9d9;\n\n              &:hover {\n                color: #d9d9d9;\n              }\n            }\n          }\n\n          .filterActions {\n            display: flex;\n            gap: 16px;\n            align-items: flex-start;\n            padding-top: 0; // Already aligned by parent\n          }\n        }\n      }\n\n      .filtersRow {\n        display: flex;\n        gap: 16px;\n        width: 100%;\n        align-items: flex-start;\n\n        .filterWidgets {\n          flex: 1;\n          display: flex;\n          flex-wrap: wrap;\n          gap: 16px;\n          align-items: flex-start;\n\n          .formField {\n            min-width: 150px;\n          }\n\n          > div {\n            min-width: 150px;\n          }\n        }\n\n        .filterActions {\n          display: flex;\n          gap: 16px;\n          align-items: flex-start;\n          padding-top: 24px; // Align with input fields that have labels\n        }\n      }\n\n      .formField {\n        padding: 0;\n        max-width: initial;\n      }\n    }\n\n    .collapsedWrapper {\n      margin-top: 16px;\n      padding-bottom: 16px;\n      display: flex;\n      flex-wrap: wrap;\n      gap: 16px;\n\n      @media @laptopM {\n        justify-content: space-between;\n      }\n    }\n  }\n\n  @media @mobileXL {\n    .header {\n      .filterForm {\n        .searchRow {\n          flex-direction: column;\n\n          .searchField {\n            width: 100%;\n          }\n\n          .searchRowActions {\n            width: 100%;\n            justify-content: flex-end;\n            padding-top: 0; // Remove padding on mobile\n\n            .filterActions {\n              padding-top: 0;\n            }\n          }\n        }\n\n        .inlineFiltersContainer {\n          flex-direction: column;\n        }\n\n        .inlineFiltersWrapper {\n          flex-wrap: wrap;\n          overflow-x: visible;\n\n          > div {\n            width: 100%;\n            flex-shrink: 1;\n          }\n        }\n\n        .clearAllButton {\n          padding-top: 0;\n          width: 100%;\n          justify-content: flex-end;\n        }\n\n        .filtersRow {\n          flex-direction: column;\n\n          .filterWidgets {\n            width: 100%;\n\n            > div {\n              width: 100%;\n            }\n          }\n\n          .filterActions {\n            width: 100%;\n            justify-content: flex-end;\n            padding-top: 0; // Remove padding on mobile\n          }\n        }\n\n        .formField {\n          width: 100%;\n        }\n      }\n    }\n  }\n\n}\n\n.nestedTable {\n  min-height: initial !important;\n\n  :global(.loadingWrapper) {\n    padding: 20px 0 0;\n  }\n}\n\n.table {\n  background: transparent;\n\n  :global(.ant-table) {\n    background: transparent;\n\n    :global(.ant-table-thead) {\n      tr {\n        th {\n          background-color: @header-color;\n          color: white;\n          border-bottom: 1px solid black;\n        }\n      }\n    }\n  }\n\n  :global(.ant-table-expanded-row) {\n    :global(.ant-table-cell) {\n      background-color: transparent;\n\n      &:hover {\n        background-color: transparent;\n      }\n    }\n  }\n\n  .row {\n    background-color: transparent;\n\n    td {\n      border-bottom: 1px solid black;\n      color: white;\n    }\n\n    &:hover {\n      td {\n        background-color: @bg-color !important;\n      }\n    }\n  }\n}\n\n.nestedTable {\n  background-color: transparent;\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n  padding-bottom: 40px;\n\n}\n\n.wrapperTranslateInput {\n  display: flex;\n  flex: 1;\n}\n\n.wrapperTranslateButton {\n  display: flex;\n  align-items: flex-end;\n  padding-bottom: 24px;\n  margin-left: 16px;\n  gap: 8px;\n\n  button {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n}\n\n.headerActions {\n  display: flex;\n  gap: 16px;\n  align-items: flex-start;\n\n  .addButton {\n\n  }\n}\n\n.nestedTable {\n  padding-bottom: 32px;\n  margin-bottom: 32px;\n}\n","@import '~antd/lib/style/themes/default.less';\n@import './breakpoints.less';\n\n// Font\n@font-family: 'Roboto', 'Oswald', BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,\n  'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',\n  'Noto Color Emoji';\n\n// Color palette\n// Cores Primárias\n@primary-100: #91cc92;\n@primary-200: #67bf65;\n@primary-300: #3cb638;\n@primary-400: #2d8d2c;\n@primary-500: #1B752B; // Cor original\n@primary-600: #165e25;\n@primary-700: #10461f;\n@primary-800: #0b2f19;\n@primary-900: #051912;\n\n// Cores Secundárias\n@secondary-100: #90a8d4;\n@secondary-200: #668bc1;\n@secondary-300: #3d6eaf;\n@secondary-400: #2f5c9f;\n@secondary-500: #2B4675; // Cor original\n@secondary-600: #23405e;\n@secondary-700: #1b3948;\n@secondary-800: #122a31;\n@secondary-900: #091c1b;\n\n// Cores Terciárias\n@tertiary-100: #d48f90;\n@tertiary-200: #c16667;\n@tertiary-300: #af3e3f;\n@tertiary-400: #9f2d2f;\n@tertiary-500: #752B1B; // Cor original\n@tertiary-600: #5e2424;\n@tertiary-700: #46201b;\n@tertiary-800: #2f180f;\n@tertiary-900: #1c0c05;\n\n// Cores de Erro\n@error-100: #d49090;\n@error-200: #c16767;\n@error-300: #af3f3f;\n@error-400: #9f2e2e;\n@error-500: #751B2B; // Cor original\n@error-600: #5e2424;\n@error-700: #461e1e;\n@error-800: #2f1515;\n@error-900: #1c0909;\n\n// Cores de Aviso\n@warning-100: #d4d490;\n@warning-200: #c1c167;\n@warning-300: #afaf3f;\n@warning-400: #9f9f2d;\n@warning-500: #75751B; // Cor original\n@warning-600: #5e5e15;\n@warning-700: #46461e;\n@warning-800: #2f2f15;\n@warning-900: #1c1c09;\n\n// Cores de Informação\n@info-100: #90d4d4;\n@info-200: #67c1c1;\n@info-300: #3fafaf;\n@info-400: #2d9f9f;\n@info-500: #1B7575; // Cor original\n@info-600: #155e5e;\n@info-700: #0f4646;\n@info-800: #092f2f;\n@info-900: #051c1c;\n\n// Cinza\n@gray-100: #d4d4d4;\n@gray-200: #c1c1c1;\n@gray-300: #afafaf;\n@gray-400: #9f9f9f;\n@gray-500: #757575; // Cor original\n@gray-600: #5e5e5e;\n@gray-700: #464646;\n@gray-800: #2f2f2f;\n@gray-900: #1c1c1c;\n\n\n// Colors\n@v2-color-primary: rgb(144, 213, 221);\n@v2-color-secondary: #72bc75;\n@green-300: rgb(137, 235, 155);\n@green-400: rgb(29, 147, 51);\n@green-500: rgb(27, 117, 43);\n@red-500: rgb(128,0,0);\n@red-400: #B00020;\n@red-300: #f77777;\n@yellow-500: rgb(204, 148, 74);\n\n@font-size-mobile: 13px;\n@font-size-base: 13px;\n\n@title-font-size: 32px;\n@title-color: @green-500;\n\n@separator: #f0f0f0;\n@oddColor: #efefef;\n\n@subtitle-font-size: 22px;\n@subtitle-color: rgb(0, 65, 75);\n\n@bg-menu-lateral: rgb(0, 65, 75);\n@icon-menu-sup-color: rgb(61, 197, 86);\n@label-color: rgb(8, 108, 124);\n\n@header-color: #005866;\n@table-header-color: #005866;\n\n// Shadows\n@v2-bg-card-shadow: 0px 0px 10px 0px rgba(0,0,0,0.25);\n@v2-bg-label-shadow: 0px 0px 10px 0px rgba(0,0,0,0.75);\n@v2-bg-overlay-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);\n@v2-bg-card-mobile-shadow: 0px 0px 5px 0px rgba(0,0,0,0.30);\n\n// Backgrounds\n@bg-color: #ffffff;\n\n// Text colors\n@text-color: #454545;\n@input-color: #333;\n\n// Dev colors\n@dev-background: #444;\n@dev-button-hover: #222;\n@v2-bg-card: rgba(255,255,255,0.1);\n\n\n\n// Sizes\n@header-height: 60px;\n@menu-width: 200px;\n\n// V2\n@v2-bg-color: #222629;\n\n\n@bg-card: #37393B;\n@dashboard-page: lighten(@bg-color, 20%);\n\n// Titles\n@v2-menu-title: #ddd;\n\n// Menu\n@v2-text-color: @text-color;\n@v2-text-color-hover: #ccc;\n\n// Animations\n@animation-time: 450ms;\n\n:global(.ant-notification) {\n  z-index: 20000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ant-notification": `ant-notification`,
	"antNotification": `ant-notification`,
	"leftMargin": `crud-module__leftMargin--enFoW`,
	"actions": `crud-module__actions--G3NaK`,
	"inlineFiltersContainer": `crud-module__inlineFiltersContainer--ZcAbL`,
	"inlineFiltersWrapper": `crud-module__inlineFiltersWrapper--GWvFa`,
	"formField": `crud-module__formField--sem7S`,
	"clearAllButton": `crud-module__clearAllButton--wjKIc`,
	"wrapper": `crud-module__wrapper--Uhgkw`,
	"header": `crud-module__header--DoVsU`,
	"filterForm": `crud-module__filterForm--Cd7ur`,
	"searchRow": `crud-module__searchRow--WT_e6`,
	"searchField": `crud-module__searchField--W5VHC`,
	"searchRowActions": `crud-module__searchRowActions--02Wp2`,
	"inlineFilterToggle": `crud-module__inlineFilterToggle--IjzG6`,
	"filterActions": `crud-module__filterActions--siw5r`,
	"filtersRow": `crud-module__filtersRow--CwYUt`,
	"filterWidgets": `crud-module__filterWidgets--YSveH`,
	"collapsedWrapper": `crud-module__collapsedWrapper--HXSrH`,
	"nestedTable": `crud-module__nestedTable--RZFZz`,
	"loadingWrapper": `loadingWrapper`,
	"table": `crud-module__table--GPSPc`,
	"ant-table": `ant-table`,
	"antTable": `ant-table`,
	"ant-table-thead": `ant-table-thead`,
	"antTableThead": `ant-table-thead`,
	"ant-table-expanded-row": `ant-table-expanded-row`,
	"antTableExpandedRow": `ant-table-expanded-row`,
	"ant-table-cell": `ant-table-cell`,
	"antTableCell": `ant-table-cell`,
	"row": `crud-module__row--vIlD4`,
	"wrapperTranslateInput": `crud-module__wrapperTranslateInput--lnfQD`,
	"wrapperTranslateButton": `crud-module__wrapperTranslateButton--rGl7u`,
	"headerActions": `crud-module__headerActions--utE46`
};
export default ___CSS_LOADER_EXPORT___;
